import React from "react"
import {Header, Image, Menu, Icon} from "semantic-ui-react"
import {FormattedMessage, useIntl} from "react-intl"
import {ScreenSize} from "../utils/media-utils"


interface ErrorPopupProps {
    screenSize: ScreenSize
    onBackHome: () => void
}

export function ErrorPage({ screenSize, onBackHome }: ErrorPopupProps) {
    const intl = useIntl()

    function desktopPage() {
        return <div className="landing" style={{ paddingTop: 48 }}>
            {/* HEADER */}
            <Header className="landing-header" textAlign="center" as="h1">
                <FormattedMessage id="landing.header.welcome"/>
                <p><FormattedMessage id="landing.header.easy"/></p>
            </Header>
            <div className="error-page">
                {/* IMAGE */}
                <Image className="error-page-image" src="/assets/error-page.svg"/>
                {/* SOMETHING WENT WRONG */}
                <div className="error-something-wrong">
                    <FormattedMessage id="error.something.wrong"/>&nbsp;
                    <FormattedMessage id="error.back.home"/>&nbsp;
                    <Menu.Item className="error-home" key="home" onClick={onBackHome}>
                        {(intl.formatMessage({ id: "menu.home" })).toLowerCase()}&nbsp;<Icon name="home"/>
                    </Menu.Item>
                </div>
                {/* ALERT */}
                <div className="error-alert-look">
                    <FormattedMessage id="error.alert" values={{alert: "🔔"}}/>&nbsp;
                    <FormattedMessage id="error.alert.look"/>
                </div>
            </div>
        </div>
    }

    function mobilePage() {
        return <div className="mobile" style={{ marginTop: 100, textAlign: "center" }}>
            {/* HEADER */}
            <div className="header-bg">
                <Header className="landing-header" textAlign="center" as="h1">
                    <FormattedMessage id="landing.header.welcome"/>
                    <p style={{ fontWeight: "bold" }}><FormattedMessage id="landing.header.easy"/></p>
                </Header>
            </div>
            <div className="mobile-error">
                {/* IMAGE */}
                <Image className="error-page-image" src="/assets/error-page.svg"/>
                {/* Something went wrong */}
                <div className="error-something-wrong">
                    <FormattedMessage id="error.something.wrong"/><br/>
                    <FormattedMessage id="error.back.home"/>&nbsp;
                    <Menu.Item className="error-home" key="home" onClick={onBackHome}>
                        {(intl.formatMessage({id: "menu.home"})).toLowerCase()}&nbsp;<Icon name="home"/>
                    </Menu.Item>
                </div>
                {/* ALERT */}
                <div className="error-alert-look">
                    <FormattedMessage id="error.alert" values={{alert: "🔔"}}/>&nbsp;
                    <FormattedMessage id="error.alert.look"/>
                </div>
            </div>
        </div>
    }

    switch (screenSize) {
        case ScreenSize.SMALL: return mobilePage()
        case ScreenSize.LARGE: return desktopPage()
    }
}